import type { RefObject } from 'react'
import { useTranslation } from 'react-i18next'
import { useStyletron } from 'baseui'
import { ChevronLeft, ChevronRight } from 'baseui/icon'
import prefersReducedMotion from '@/shared/tools/prefersReducedMotion'
import { useRightPanel } from './rightPanelContext'

const useRightPanelToggle = (toggleRef: RefObject<HTMLElement>) => {
  const { t } = useTranslation()
  const [, theme] = useStyletron()
  const { expanded, toggle } = useRightPanel()

  const onToggle = () => {
    toggle()
    if (expanded) return
    const behavior = prefersReducedMotion() ? 'auto' : 'smooth'
    window.requestAnimationFrame(() => toggleRef.current?.scrollIntoView({ behavior, block: 'nearest' }))
  }

  return {
    expanded,
    onToggle,
    Icon: expanded ? ChevronRight : ChevronLeft,
    iconColor: theme.colors.primary,
    label: t(expanded ? 'common:collapse_panel' : 'common:expand_panel'),
  }
}

export default useRightPanelToggle
